if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.isHhsHardHat = this.dataset.hhsHardHat === 'true';
        this.hhsNameToggle = this.querySelector('[data-hhs-name-toggle]');
        this.hhsNameField = this.querySelector('[data-hhs-name-field]');
        this.hhsNameInput = this.querySelector('[data-hhs-name-input]');
        if (this.hhsNameToggle && this.hhsNameField && this.hhsNameInput) {
          this.hhsNameToggle.addEventListener('change', () => {
            const enabled = this.hhsNameToggle.checked;
            this.hhsNameField.hidden = !enabled;
            this.hhsNameInput.required = enabled;
            if (enabled) this.hhsNameInput.focus();
            if (!enabled) this.hhsNameInput.value = '';
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (this.isHhsHardHat) {
          this.submitHhsBundle();
          return;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async submitHhsBundle() {
        const formData = new FormData(this.form);
        const selectedId = Number(formData.get('id'));
        const quantity = Math.max(1, Number(formData.get('quantity') || 1));
        const wantsName = Boolean(this.hhsNameToggle && this.hhsNameToggle.checked);
        const nameValue = this.hhsNameInput ? this.hhsNameInput.value.trim() : '';
        const wantsTumbler = Boolean(this.querySelector('[data-hhs-tumbler-toggle]')?.checked);
        const wantsSticker = Boolean(this.querySelector('[data-hhs-sticker-toggle]')?.checked);

        if (wantsName && !nameValue) {
          this.handleErrorMessage('Please enter the name exactly as it should appear on the hard hat.');
          this.resetHhsSubmitState();
          if (this.hhsNameInput) this.hhsNameInput.focus();
          return;
        }

        const bundleId = `HHS-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        const productTitle = this.dataset.hhsProductTitle || 'Hard Hat';
        const parentProperties = { '_HHS Bundle': bundleId };

        for (const [key, value] of formData.entries()) {
          const propertyMatch = /^properties\[(.+)\]$/.exec(key);
          if (propertyMatch && value) parentProperties[propertyMatch[1]] = value;
        }
        if (wantsName) parentProperties['Personalized Name'] = nameValue;

        const items = [{ id: selectedId, quantity, properties: parentProperties }];

        if (wantsName) {
          items.push({
            id: Number(this.dataset.hhsNameVariant),
            quantity,
            properties: {
              'Name': nameValue,
              'For Hard Hat': productTitle,
              '_HHS Bundle': bundleId,
            },
          });
        }

        if (wantsTumbler) {
          items.push({
            id: Number(this.dataset.hhsTumblerVariant),
            quantity,
            properties: {
              'Matches Hard Hat': productTitle,
              '_HHS Bundle': bundleId,
            },
          });
        }

        if (wantsSticker) {
          items.push({ id: Number(this.dataset.hhsStickerVariant), quantity: 1 });
        }

        const requestBody = { items };
        if (this.cart) {
          requestBody.sections = this.cart.getSectionsToRender().map((section) => section.id);
          requestBody.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify(requestBody);

        try {
          const response = await fetch(`${routes.cart_add_url}`, config).then((result) => result.json());

          if (response.status) {
            this.handleErrorMessage(response.description || response.message || 'We could not add this order to the cart.');
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: selectedId,
              errors: response.errors || response.description,
              message: response.message,
            });
            this.error = true;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: selectedId,
            cartData: response,
          });
          this.error = false;

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => setTimeout(() => this.cart.renderContents(response)),
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        } catch (error) {
          console.error(error);
          this.handleErrorMessage('Something went wrong. Please try adding your order again.');
          this.error = true;
        } finally {
          this.resetHhsSubmitState();
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        }
      }

      resetHhsSubmitState() {
        this.submitButton.classList.remove('loading');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
